'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeWidth={2} d="M19.895 2c.796 0 1.325 0 1.706.035.178.016.284.037.342.052q.008.038.018.104c.037.267.039.654.039 1.309v13c0 1.66-.306 3.033-.994 3.971-.645.88-1.74 1.529-3.706 1.529H5v-.061c.712-.108 1.407-.398 1.885-1.155.307-.486.469-1.085.563-1.754.095-.678.131-1.514.131-2.53v-13c0-.602.002-.976.034-1.245q.015-.11.027-.159c.04-.011.103-.026.2-.04C8.13 2.013 8.555 2 9.224 2zm2.028.018.002.004z" /><path stroke="currentColor" strokeLinejoin="round" strokeWidth={2} d="M4.999 22c-2.47 0-3-1.5-2.998-5 .03-1.5 0-7 0-7h5.498M11 9.5v-4h8v4z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 13.5h8M11 17.5h6" /></svg>;
const IconNewsroom = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconNewsroom;